import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeDeleteSynthesisSession } from "../../domain/use-cases/delete-synthesis-session"
import { httpSynthesisSessionRepository } from "../../data/repositories/synthesis-session-repository"

const del = makeDeleteSynthesisSession(httpSynthesisSessionRepository)

export const useDeleteSynthesisSession = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => del(id),
    onSuccess: (_, id) => {
      void qc.removeQueries({ queryKey: ["synthesis-sessions", id] })
      void qc.invalidateQueries({
        queryKey: ["synthesis-sessions"],
        exact: true,
      })
    },
  })
}
